/** @module molStickySidebar - The purpose of the module is to be a wrapper over the StikySidebar component that can be easily used in different places without custom code to be build,
 */
define([
    'require',
    'jquery',
    'pubsub'
], function(require, $, pubsub) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'molStickySidebar';
// Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function() {
            var self = this;

            console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            // Initialize events
            self.events();

            // Do any DOM manipulation or other setup
            self._build();
            if( self.config.isAutoLoad){
                self.initSideBar();
            }
            // Allow JQuery-style chaining of the plugin
            return self;
        },
        /**
         * Start initialization procedure of the module, initialize the stickSidebar,
         * @returns {void}
         */
        initSideBar: function (callback, fullReInit) {
            var self = this;
            if( self.config.disableScroll) {
                return;
            }
            if( self.isInitialized && !fullReInit){
                self.stickySidebar.updateSticky();
                return;
            }
            self.unloadSideBar();
            require(['sticky-sidebar'], function(){
                //set default sticky sidebar variables
                self.stickySidebar = new StickySidebar(self.config.sidebarSelector, {
                    containerSelector: self.config.containerSelector,
                    innerWrapperSelector: self.config.innerWrapperSelector,
                    bottomSpacing: self.config.bottomSpacing,
                    topSpacing: self.config.topSpacing,
                    minWidth: 640, //small screen width transition, disable sticky sidebar
                    resizeSensor: true
                });
                self.$stickyInner = $(self.config.innerWrapperSelector);
                self.isInitialized = true;
                if( callback){
                    callback(self.stickySidebar);
                }

            });

        },
        /**
         * A proper way to destroy the stickySidebar object, Currently it is not used, but should be if needed
         * @returns {void}
         */
        unloadSideBar: function () {

            //remove all previous sticky sidebar instances
            if (this.stickySidebar) {
                this.stickySidebar.destroy();
            }
            this.isInitialized = false;
        },
        /**
         * This is a workaround for the edge cases when there is a height change of the container and we are in
         * certain state of the sticky identified by following state variables of the sticky library
         * direction: up
         * afixedType: VIEWPORT-UNBOTTOM || false
         * position: relative
         * This is a bug in sticky library - and it is intermediate state that is not handled by any cases (the state machine of the sticky library)
         * It could be achieved if you instead of scrolling down to a page - directly ctrl+end to the bottom and then a bit up, and then resize the sticky panel
         * @returns {void}
         */
        recalculateProperBottom: function() {
            var self = this;
            var position = self.$stickyInner.css('position');

            if (position == 'relative' && (self.stickySidebar.affixedType === 'VIEWPORT-UNBOTTOM' || self.stickySidebar.affixedType === false) && self.stickySidebar.direction === 'up') {
                //Calculation of correct coordinate:
                var containerTop = self.offsetRelative(self.stickySidebar.container).top;
                var containerHeight = self.stickySidebar.container.clientHeight;
                var containerBottom = containerTop + containerHeight;
                var sidebarHeight = self.stickySidebar.sidebarInner.offsetHeight;
                var sidebarBottom = sidebarHeight + containerTop;
                var translateY = containerBottom - sidebarBottom;
                self.stickySidebar.dimensions.translateY = translateY;
                //Update the coordinate
                var transformCss = self.setupTranslateCoordinates(0, translateY, 0);
                self.$stickyInner.css('transform', transformCss);
            }
        },
        /**
         * This is a part of a workaround solution that is fixing the issue with the sticky library.
         * Once the sticky library is fixed, then -  this could be removed from the code and as a test.
         **/
        setupTranslateCoordinates: function (x, y, z) {
            if (this.stickySidebar.support.transform3d) return 'translate3d(' + y + ', ' + x + ', ' + z + ')';else if (this.support.translate) return 'translate(' + y + ', ' + x + ')';else return false;
        },
        /**
         * This is a part of a workaround solution that is fixing the issue with the sticky library.
         * Once the sticky library is fixed, then -  this could be removed from the code and as a test.
         **/
        offsetRelative: function(element) {
            var result = { left: 0, top: 0 };
            do {
                var offsetTop = element.offsetTop;
                var offsetLeft = element.offsetLeft;

                if (!isNaN(offsetTop)) result.top += offsetTop;

                if (!isNaN(offsetLeft)) result.left += offsetLeft;

                element = 'BODY' === element.tagName ? element.parentElement : element.offsetParent;
            } while (element);
            return result;
        },
        /**
         * This is a part of a workaround solution that is fixing the issue with the sticky library.
         * Once the sticky library is fixed, then -  this could be removed from the code and as a test.
         * This checks whether the sticky is near the bottom, where there is a need of manual recalculation of the height during resize
         **/
        checkForManualResize: function() {
            if (!this.stickySidebar) {
                return;
            }
            return ((this.stickySidebar.affixedType === 'VIEWPORT-UNBOTTOM' || this.stickySidebar.affixedType === 'CONTAINER-BOTTOM' ||
                    this.stickySidebar.affixedType === false) || (this.stickySidebar.affixedType === 'VIEWPORT-TOP' && this.stickySidebar.direction === 'up')
            );
        },
        /**
         * Binds plugin events
         **/
        events: function() {
            var self = this;
            // create event listeners here

            // Subscribe to video fullscreen change events and enable / disable sticky sidebar behavior
            $.pubsub('subscribe','vfdp.aem.videojsplayer.fullscreenchange', function(event, data) {
                // only execute this if on a futurelight page
                if($('.pdp-alternate-view-enabled').length) {

                    if (data.isFullscreen) {
                        var molStickySidebar = $('.mol-sticky-sidebar');
                        molStickySidebar.addClass('mol-sticky-sidebar-disabled').removeClass('mol-sticky-sidebar'); 
                    } else {
                        var molStickySidebarDisabled = $('.mol-sticky-sidebar-disabled'); 
                        molStickySidebarDisabled.addClass('mol-sticky-sidebar').removeClass('mol-sticky-sidebar-disabled');
                    }
                    
                }
                
            });
        },

        /**
         * Modifies the DOM to support layout requirements
         **/
        _build: function() {
            var self = this;
            self.selector = $(self.element);
        }
    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
